import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const locationStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  address: {
    color: 'info.main',
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,
}
